import { useTicketStatuses } from "@jugl-web/domain-resources/tickets/hooks/useTicketStatuses";
import { TicketStatus } from "@jugl-web/rest-api/tickets/models/common-types";
import { TicketPropertyPill } from "@jugl-web/domain-resources/tickets/components/TicketPropertyPill";
import { TicketStatusPickerPopover } from "@web-src/modules/client-support/components/TicketStatusPickerPopover";
import { FC, useMemo } from "react";
import { TicketDetailItem } from "../TicketDetailItem";

interface StatusDetailItemProps {
  status: TicketStatus;
  onChange: (status: TicketStatus) => void;
}

export const StatusDetailItem: FC<StatusDetailItemProps> = ({
  status,
  onChange,
}) => {
  const { getStatusById } = useTicketStatuses();

  const statusDetails = useMemo(
    () => getStatusById(status),
    [status, getStatusById]
  );

  const statusPill = (
    <TicketPropertyPill
      className="[&_svg]:size-4"
      icon={statusDetails.icon}
      label={statusDetails.label}
    />
  );

  return (
    <TicketStatusPickerPopover
      status={status}
      onChange={onChange}
      renderTrigger={({ Trigger, triggerRef, isOpen }) => (
        <Trigger
          as={TicketDetailItem}
          ref={triggerRef}
          isInteractive
          isActive={isOpen}
          label="Status"
          content={statusPill}
        />
      )}
    />
  );
};
